import React, { useState, useContext } from "react";
import SearchInput from "../searchInput/SearchInput";
import RRDistribuciones from "../renderRows/RRDistribuciones";
import windowSizeContext from "../../context/windowSize/windowSizeContext";
import './DistribucionList.css';

function DistribucionList({ distribucionesConSubcuentas = [] }) {

    const [filter, setFilter] = useState("");

    const wSizeContext = useContext(windowSizeContext);
    const { height } = wSizeContext;

    const handdlerSearchInput = (data) => {
        setFilter(data);
    };

    return (
        <div>
            <div style={{ marginLeft: "-150px" }}>
                <SearchInput defaultValue={filter} buscar={handdlerSearchInput} />
            </div>
            <div className='distribucionesListDiv' style={{ height: height - 200, overflowY: 'scroll' }}>
                {
                    distribucionesConSubcuentas
                        .filter(d =>
                            d.codDis.toLowerCase().includes(filter.toLowerCase()) ||
                            d.descrp.toLowerCase().includes(filter.toLowerCase()) ||
                            d.codDim.toLowerCase().includes(filter.toLowerCase())
                        )
                        .map((d, index) => (
                            <RRDistribuciones
                                key={index}
                                index={index}
                                style={{}}
                                distribucionesConSubcuentas={distribucionesConSubcuentas}
                                filter={filter}
                            />
                        ))
                }
            </div>
        </div>
    );
}

export default DistribucionList;
